module.exports = __webpack_public_path__ + "img/khipu.0c2d005e.png";